import React from "react";

import {
  REACH_WHY_HIRE,
  REACH_WHY_INTERVIEWS,
  REACH_WHY_PLACEMENT,
  REACH_WHY_PROJECTS,
} from "../../utils/reachMedia";

import ReachRim from "../ReachRim/ReachRim";

import "./WhyStudentsChooseDark.css";

const FEATURES = [
  {
    title: "Learn What Companies Hire For",
    description:
      "Build industry-relevant skills through our Full Stack + AI program.",
    icon: REACH_WHY_HIRE,
    iconSize: 32,
  },
  {
    title: "Build Real-World Projects",
    description:
      "Work on practical projects that strengthen your portfolio and resume.",
    icon: REACH_WHY_INTERVIEWS ,
    iconSize: 35,
  },
  {
    title: "Prepare for Interviews",
    description:
      "Practice with mock interviews and company-specific interview preparation.",
    icon: REACH_WHY_PLACEMENT ,
    iconSize: 30,
  },
  {
    title: "Placement Support",
    description:
      "Receive guidance throughout your placement journey until you land a software job.",
    icon: REACH_WHY_PROJECTS,
    iconSize: 30,
  },
];

export default function WhyStudentsChooseDark() {
  return (
    <section className="why-students-choose-dark">
      <div className="w-layout-blockcontainer intensive-container w-container">
        <h2 className="why-students-choose-dark__heading">
          Why Students Choose NxtWave Intensive
        </h2>
        <div className="why-students-choose-dark__grid">
          {FEATURES.map((feature) => (
            <ReachRim
              key={feature.title}
              variant="feature"
              className="why-students-choose-dark__card"
            >
              <div className="why-students-choose-dark__icon-wrap">
                <div
                  className="why-students-choose-dark__icon-media"
                  style={{
                    width: feature.iconSize,
                    height: feature.iconSize,
                  }}
                >
                  <img
                    src={feature.icon}
                    alt=""
                    className="why-students-choose-dark__icon"
                    loading="lazy"
                  />
                </div>
              </div>
              <div className="why-students-choose-dark__text">
                <h3 className="why-students-choose-dark__title">{feature.title}</h3>
                <p className="why-students-choose-dark__desc">{feature.description}</p>
              </div>
            </ReachRim>
          ))}
        </div>
      </div>
    </section>
  );
}
